export default "__VITE_ASSET__8BW7wF7P__"